// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductItem_root__2a7M1","productLink":"ProductItem_productLink__3Mf1h","productLikeBtn":"ProductItem_productLikeBtn__KVyar"};